// extracted by mini-css-extract-plugin
export var currencyInput = "_nj-1";
export var currencySymbol = "_nj-0";